export default __webpack_public_path__ + "6c07feec0a00169c99879670c283bcba.png";